module.exports = __webpack_public_path__ + "static/img/activity04.76db2ab2.png";